import { QUEST_ACTION } from '../../../constants/actions'
import { mergeToNewObject } from '../../../util/object.helpers'
import {
  sortDataByDate,
  sortRecordsByTitle
} from '../../../util/common.helpers'
import {
  QUEST_SORTING_OPTIONS,
  QUEST_STATUS_OPTIONS
} from '../../../util/quest.helpers'

export const questListProfile = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case QUEST_ACTION.ON_GET_QUESTS:
      return mergeToNewObject(state, {
        loading: true
      })

    case QUEST_ACTION.ON_GET_QUESTS_SUCCESS:
      return mergeToNewObject(state, {
        loading: false,
        data: payload,
        filteredData: sortData(state.sorting, payload)
      })

    case QUEST_ACTION.ON_GET_QUESTS_FAILED:
      return mergeToNewObject(state, {
        loading: false
      })

    case QUEST_ACTION.CHANGE_LIST_STATE:
      const { property, value } = payload
      return mergeToNewObject(state, {
        [property]: value,
        ...(property === QUEST_LIST_PROFILE_DISPATCH.SORTING && {
          filteredData: sortData(value, state.filteredData)
        }),
        ...(property === QUEST_LIST_PROFILE_DISPATCH.STATUS && {
          filteredData: filterData(value, state)
        })
      })

    case QUEST_ACTION.ON_CREATE_QUEST_SUCCESS:
      const data = [...state.data, payload]
      return mergeToNewObject(state, {
        data,
        status: QUEST_STATUS_OPTIONS.ALL,
        filteredData: filterData(QUEST_STATUS_OPTIONS.ALL, {
          data,
          sorting: state.sorting
        })
      })

    case QUEST_ACTION.ON_UPDATE_QUEST_SUCCESS:
      const updatedData = state.data.map((record) =>
        payload.id === record.id ? payload : record
      )
      return mergeToNewObject(state, {
        data: updatedData,
        status: QUEST_STATUS_OPTIONS.ALL,
        filteredData: filterData(QUEST_STATUS_OPTIONS.ALL, {
          data: updatedData,
          sorting: state.sorting
        })
      })

    // case QUEST_ACTION.ON_UPDATE_QUEST_FAILED:
    //   return mergeToNewObject(state, {
    //     selected: null
    //   })

    case QUEST_ACTION.ON_SELECT:
      const { data: selected, isListUpdate } = payload
      return mergeToNewObject(state, {
        selected,
        isListUpdate
      })

    case QUEST_ACTION.ON_RESET_LIST:
      return INITIAL_STATE

    default:
      return state
  }
}

const INITIAL_STATE = {
  loading: false,
  data: [],
  filteredData: [],
  selected: null,
  isListUpdate: false,
  sorting: QUEST_SORTING_OPTIONS.DESC,
  status: QUEST_STATUS_OPTIONS.ALL
}

export const QUEST_LIST_PROFILE_DISPATCH = {
  SORTING: 'sorting',
  STATUS: 'status'
}

const sortData = (order, data) => {
  switch (order) {
    case QUEST_SORTING_OPTIONS.AZ:
    case QUEST_SORTING_OPTIONS.ZA:
      return sortRecordsByTitle(data, order)
    case QUEST_SORTING_OPTIONS.ASC:
    case QUEST_SORTING_OPTIONS.DESC:
      return sortDataByDate(data, order)
    default:
      return sortDataByDate(data)
  }
}

const filterData = (status, { data, sorting }) => {
  switch (status) {
    case QUEST_STATUS_OPTIONS.ACTIVE:
    case QUEST_STATUS_OPTIONS.STOPPED:
      return sortData(
        sorting,
        data.filter((record) => record.status === status)
      )
    default:
      return sortData(sorting, data)
  }
}
